/**
 * Translation imports and LOCAL_TRANSLATIONS export
 *
 * This module imports all JSON translation files and merges them into
 * a single LOCAL_TRANSLATIONS object. The type of this object is inferred
 * from the JSON imports and used for type-safe i18next integration.
 *
 * @example
 * ```typescript
 * import { LOCAL_TRANSLATIONS } from '@fmc-digital/i18n';
 *
 * // Type is inferred from JSON structure
 * type TranslationKeys = keyof typeof LOCAL_TRANSLATIONS;
 * ```
 */
// Translations
import common from "./locales/common.json";
import errors from "./locales/errors.json";
import forgotEmail from "./locales/forgotEmail.json";
import forgotPassword from "./locales/forgotPassword.json";
import login from "./locales/login.json";
import mfa from "./locales/mfa.json";
import mortgage from "./locales/mortgage.json";
import register from "./locales/register.json";
/**
 * Merged translations for local/development mode.
 * This object's type is inferred from the JSON imports and used
 * for i18next module augmentation to provide type-safe translation keys.
 */
export const LOCAL_TRANSLATIONS = {
    ...common,
    auth: {
        ...login.auth,
        ...register.auth,
        ...mfa.auth,
        ...forgotPassword.auth,
        ...forgotEmail.auth,
    },
    ...errors,
    ...mortgage,
};
/**
 * All translations by language code for local mode initialization.
 */
export const translations = {
    en: LOCAL_TRANSLATIONS,
};
/**
 * Supported language codes.
 */
export const SUPPORTED_LANGUAGES = ["en"];
/**
 * Gets all supported language codes.
 */
export function getSupportedLanguages() {
    return [...SUPPORTED_LANGUAGES];
}
//# sourceMappingURL=translations.js.map